import React, {FC} from 'react'

import PrismicLink, {Props as PrismicLinkProps} from '@helios/shared/components/prismic-link'
import RichText, {Props as RichTextProps, hasRichText} from '@helios/shared/components/rich-text'
import {Text, TextLink} from '@helios/shared/styles/typography'
import ImageSource from '@helios/shared/types/image'

import * as s from './card.styles'

type Tag = {
    text: string
    color: s.TagProps['$color']
}

export interface Props {
    image?: ImageSource
    title: string
    body?: RichTextProps['content']
    ctaText?: string
    ctaLink?: string | PrismicLinkProps
    imageFit?: 'contain' | 'cover'
    className?: string
    tag?: Tag
}

const Card: FC<Props> = ({
    image,
    title,
    body,
    ctaText,
    ctaLink,
    imageFit = 'contain',
    className,
    tag,
}) => {
    const bodyTextProps = {
        size: 'xs',
        font: 'secondary',
    } as const

    return (
        <s.Wrapper hasImage={!!image} className={className}>
            {!!image && <s.Image image={image} $imageFit={imageFit} />}

            <s.Content>
                <s.TextWrapper>
                    <Text>{title}</Text>

                    {hasRichText(body) && (
                        <RichText {...bodyTextProps} content={body} color="muted" />
                    )}
                </s.TextWrapper>

                <s.TagAndLink>
                    {tag && (
                        <s.Tag $color={tag.color}>
                            <Text as="span" variant="label-base" color="muted">
                                {tag.text}
                            </Text>
                        </s.Tag>
                    )}

                    {!!ctaLink && typeof ctaLink === 'string' && !!ctaText && (
                        <TextLink {...bodyTextProps} href={ctaLink}>
                            {ctaText} →
                        </TextLink>
                    )}

                    {!!ctaLink && typeof ctaLink !== 'string' && !!ctaText && (
                        <TextLink {...bodyTextProps} as={PrismicLink} {...ctaLink}>
                            {ctaText} →
                        </TextLink>
                    )}
                </s.TagAndLink>
            </s.Content>
        </s.Wrapper>
    )
}

export default Card
